import List from "@mui/material/List";

import { NotificationTypes } from "../../../helpers/notificationsTypes";
import { useRemoveNotification } from "../../../hooks/useNotifications";
import { CommentNotification } from "./Comment";
import { CommentAnswerNotification } from "./CommentAnswer";
import { CommentLikeNotification } from "./CommentLike";
import { ForumQuestionAnswerNotification } from "./ForumQuestionAnswer";
import { InfoNotification } from "./Info";
import { LinkNotification } from "./Link";
import { LocalLinkNotification } from "./LocalLink";
import { QuestionChangedNotification } from "./QuestionChanged";
import { ReportedErrorResponseNotification } from "./ReportedErrorResponse";

export const NotificationStatus = {
	waiting: "waiting",
	resolved: "resolved",
} as const;

export interface NotificationData {
	id: string;
	type: string;
	status: string;
	itemId: string;
	message: string;
	username: string;
	url: string;
	createdAt: string;
	endDate: string;
}

interface NotificationListProps {
	notifications: NotificationData[][] | undefined;
}

export function NotificationList({ notifications }: NotificationListProps) {
	const { mutateAsync } = useRemoveNotification();

	const removeNotification = (notification: NotificationData) => {
		return (mutateAsync as any)(notification);
	};

	const renderNotifications = () => {
		if (!notifications) {
			return null;
		}

		return notifications.map((page) => {
			return page.map((notification) => {
				if (notification.type === NotificationTypes.commentLike) {
					return (
						<CommentLikeNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.questionComment) {
					return (
						<CommentNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.forumQuestionAnswer) {
					return (
						<ForumQuestionAnswerNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.link) {
					return (
						<LinkNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.localLink) {
					return (
						<LocalLinkNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.info) {
					return (
						<InfoNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.reportedErrorResponse) {
					return (
						<ReportedErrorResponseNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.questionChanged) {
					return (
						<QuestionChangedNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				if (notification.type === NotificationTypes.commentAnswer) {
					return (
						<CommentAnswerNotification
							key={notification.id}
							notification={notification}
							removeNotification={() => removeNotification(notification)}
						/>
					);
				}

				return null;
			});
		});
	};

	return <List className="p-0">{renderNotifications()}</List>;
}
